import { render, staticRenderFns } from "./CouponTable.vue?vue&type=template&id=71ca36a9&scoped=true&"
import script from "./CouponTable.vue?vue&type=script&lang=ts&"
export * from "./CouponTable.vue?vue&type=script&lang=ts&"
import style0 from "./CouponTable.vue?vue&type=style&index=0&id=71ca36a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ca36a9",
  null
  
)

export default component.exports